
import lazyLoadComponent from "@/scripts/lazyLoadComponent";
import SkeletonBox from "@/views/component/SkeletonBox";
import { mapState } from "vuex";
import stakingApi from "@/api/stakingApi";
export default {

  components: {
    StakingHistory: lazyLoadComponent({
            componentFactory: () => import("@/views/StakingPoint/StakingHistory"),
            loading: SkeletonBox
        }),
    },
    data() {
        return {
            isLoading: false,
            isShowHistory: false,
            dialogConfirmVisible: false,
            amountPresetList: [0.2, 0.3, 0.5, 0.8, 1],
            stakingTypes: [
                { value: 1, label: 'Limited time' }, 
                { value: 2, label: 'Unlimited time' }
            ],
            stakingTimes: [],
            stakingForm: {
                typeOfStaking: 1,
                stakingTime: 1,
                amount: 0,
                checkedTerm: false,
            },
            campaign: null,
            currentPolicy: null,
            currentTab: 'STAKE_TO_EARN',
        }
    },
    watch: {
        // exactAmountPresetList(newVal){
        //     if(newVal.length > 0){
        //         this.stakingForm.amount = newVal[0];
        //     }
        // }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            tempBalance: state => state.auth.tempBalance,
        }),
        canSubmit() {
            return this.campaign !== null && this.currentPolicy !== null 
                && this.stakingForm.amount > 0 && this.stakingForm.checkedTerm
                && this.stakingForm.amount >= this.campaign.minimumAmount
                && this.stakingForm.amount <= this.user.balance;
        },
        exactAmountPresetList(){
            if(this.campaign){
                return this.amountPresetList;
            }
            else return [];
        },
        interestValueFor1Month(){
            if(this.currentPolicy && this.currentPolicy !== null && this.stakingForm.amount
                && this.stakingForm.amount >= this.campaign.minimumAmount)  {
                return (this.currentPolicy.interestRate/100 * this.stakingForm.amount).toFixed(2)
            }
            return 0;
        }
    },
    mounted() {
        this.loadConfig();
    },
    methods: {
        loadConfig(){
            this.stakingForm = {
                typeOfStaking: 1,
                stakingTime: 1,
                amount: 0,
                checkedTerm: false,
            };
            this.isLoading = true;
            Promise.all([this.getActiveCampaign(), this.getActivePolicy(), this.getActiveTime()])
            .then((res) => {
                this.isLoading = false;
                try{
                    if(res[0].data.result === 0){
                        if(res[0].data.data && res[0].data.data.length > 0) {
                            this.campaign = res[0].data.data[0];
                        }
                    }
                    else this.campaign = null;
    
                    if(res[1].data.result === 0){
                        if(res[1].data.data) {
                            this.currentPolicy = res[1].data.data;
                        }
                    }
                    else this.currentPolicy = null;
    
                    if(res[2].data.result === 0){
                        if(res[2].data.data && res[2].data.data.length > 0) {
                            this.stakingTimes = res[2].data.data;
                        }
                    }
                    else this.stakingTimes = [];
                }
                catch(err){
                    console.error(err)
                }

                this.isLoading = false;
            })
            .catch(err => {
                this.isLoading = false;
                console.error(err)
            })
        },
        getActiveCampaign() {
            return stakingApi.getActiveCampaign()
        },
        getActivePolicy() {
            if(this.stakingForm && this.stakingForm.typeOfStaking){
                return stakingApi.getActivePolicy({
                    stakingType: this.stakingForm.typeOfStaking,
                    amount: this.stakingForm.amount,
                    numberOfMonth:  this.stakingForm.stakingTime,
                })
            }
            else{
                return new Promise((resolve) => {
                    resolve({ data: { result: 1 }})
                })
            }
        },
        getActiveTime(){
            if(this.stakingForm && this.stakingForm.typeOfStaking){
                return stakingApi.getActiveTime({
                    stakingType: this.stakingForm.typeOfStaking,
                    amount: this.stakingForm.amount
                })
            }
            else{
                return new Promise((resolve) => {
                    resolve({ data: { result: 1 }})
                })
            }
        },
        
        recalc(){
            this.isLoading = true;
            Promise.all([this.getActivePolicy()])
            .then((res) => {
                this.isLoading = false;
                try{
                    if(res[0].data.result === 0){
                        if(res[0].data.data) {
                            this.currentPolicy = res[0].data.data;
                        }
                    }
                    else this.currentPolicy = null;
                }
                catch(err){
                    console.error(err)
                }
                this.isLoading = false;
            })
            .catch(err => {
                this.isLoading = false;
                console.error(err)
            })
        },
        showConfirm(){
            this.dialogConfirmVisible = true;
        },
        submit() {
            this.isLoading = true;             
                stakingApi.stakeTransaction({
                    ...this.stakingForm,
                    campaignId: this.campaign.id,
                })
                .then((res) => {  
                    if(res.data.result === 0){  
                        this.dialogConfirmVisible = false;    
                        this.$message({
                            type: 'success',
                            message: this.$t('staking.stakeSuccess')
                        });
                        this.currentTab = 'STAKING_HISTORY';      
                        if(this.$refs.StakingHistory && this.$refs.StakingHistory.getTransactionOfUser){
                            this.$refs.StakingHistory.getTransactionOfUser();
                        }        
                        this.$store.dispatch("auth/basicUserInformationView");
                        this.$store.dispatch("auth/getTempBalance");
                        this.loadConfig();
                    }
                    else{                        
                        this.$message({
                            type: 'error',
                            message: this.$t('staking.genericError')
                        });
                    }
                    setTimeout(() => {                        
                        this.isLoading = false;
                    }, 1000);
                }).catch(() => {
                    this.loadConfig();
                    this.isLoading = false;
                    this.$message({
                        type: 'error',
                        message: this.$t('staking.genericError')
                    });
                });
            // this.$confirm('Are you sure performce staking point action. Continue?', 'Summary', {
            //     confirmButtonText: 'OK',
            //     cancelButtonText: 'Cancel',
            //     type: 'warning'
            // }).then(() => {   
                
            // }).catch(() => {
            //     this.loadConfig();
            //  });
        }
    }
}